import isAuth from "@/middleware/isAuth";

export default [
  {
    path: "/teacher/grades",
    name: "teacher_grades",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Grades" */ "@/views/teacher/grades/"
      ),
    meta: {
      teacherRouteName: "grades",
      layout: "default",
      title: "manage_grades",
      description: "manage_organize_grades",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/grades/:gradeId/edu-classes",
    name: "teacher_edu_classes",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Edu Classes" */ "@/views/teacher/grades/eduClasses/"
      ),
    meta: {
      teacherRouteName: "edu_classes",
      layout: "default",
      title: "manage_edu_classes",
      description: "manage_organize_edu_classes",
      middleware: [isAuth],
    },
  },

  {
    path: "/teacher/grades/:gradeId/edu-classes/:eduClassId",
    name: "edu_class_show",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Edu Classes Show" */ "@/views/teacher/grades/eduClasses/show.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_edu_classes",
      description: "manage_organize_edu_classes",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/grades/:gradeId/subjects",
    name: "teacher_subjects",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Subjects" */ "@/views/teacher/grades/subjects/index.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_subjects",
      description: "manage_organize_subjects",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/grades/:gradeId/subjects/:subjectId/curricula",
    name: "teacher_curricula",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Curricula" */ "@/views/teacher/grades/subjects/curricula/index.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_curricula",
      description: "manage_organize_curricula",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/grades/:gradeId/subjects/:subjectId/curricula/:curriculumId/units",
    name: "teacher_units",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Units" */ "@/views/teacher/grades/subjects/curricula/units/index.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_units",
      description: "manage_organize_units",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/grades/:gradeId/subjects/:subjectId/curricula/:curriculumId/units/:unitId/lessons",
    name: "teacher_lessons",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Lessons" */ "@/views/teacher/grades/subjects/curricula/units/lessons/index.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_lessons",
      description: "manage_organize_lessons",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/grades/:gradeId/subjects/:subjectId/curricula/:curriculumId/units/:unitId/lessons/:lessonId/academic-content",
    name: "teacher_academic_content",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Academic Content" */ "@/views/teacher/grades/subjects/curricula/units/lessons/academicContent/index.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_academic_content",
      description: "manage_organize_academic_content",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/holidays",
    name: "teacher_holidays",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Holidays" */ "@/views/teacher/holidays/index.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "holidays",
      title: "manage_holidays",
      description: "manage_organize_holidays",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan",
    name: "teacher_study_plan",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan" */ "@/views/teacher/study-plan/index.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "study_plan",
      description: "my_study_plans_subtitle",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan/:curriculumId",
    name: "teacher_study_plan_show",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan Show" */ "@/views/teacher/study-plan/show.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "study_plan",
      description: "my_study_plans_subtitle",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan/:curriculumId/lessons/:itemId",
    name: "teacher_study_plan_lesson",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan Lesson" */ "@/views/teacher/study-plan/lesson.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "study_plan",
      description: "manage_lesson_materials",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan/:curriculumId/lessons/:itemId/academic-content",
    name: "teacher_study_plan_lesson_academic_content",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan Lesson Content" */ "@/views/teacher/grades/subjects/curricula/units/lessons/academicContent/index.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "manage_academic_content",
      description: "manage_organize_academic_content",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan/:curriculumId/lessons/:itemId/questions",
    name: "teacher_study_plan_lesson_questions",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan Lesson Questions" */ "@/views/teacher/grades/subjects/curricula/units/lessons/questions/index.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "manage_questions",
      description: "manage_organize_questions",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan/:curriculumId/lessons/:itemId/questions/create",
    name: "teacher_study_plan_lesson_questions_create",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan Lesson Question Create" */ "@/views/teacher/grades/subjects/curricula/units/lessons/questions/create.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "manage_questions",
      description: "manage_organize_questions",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan/:curriculumId/lessons/:itemId/questions/edit/:questionId",
    name: "teacher_study_plan_lesson_questions_edit",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan Lesson Question Edit" */ "@/views/teacher/grades/subjects/curricula/units/lessons/questions/edit.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "manage_questions",
      description: "manage_organize_questions",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan/:curriculumId/lessons/:itemId/quizzes/create",
    name: "teacher_study_plan_lesson_quizzes_create",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan Lesson Quiz Create" */ "@/views/teacher/grades/eduClasses/quizzes/create.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "add_class_quiz",
      description: "manage_class_quizzes",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan/:curriculumId/lessons/:itemId/quizzes/:quizId/edit",
    name: "teacher_study_plan_lesson_quizzes_edit",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan Lesson Quiz Edit" */ "@/views/teacher/grades/eduClasses/quizzes/edit.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "edit_class_quiz",
      description: "manage_class_quizzes",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan/:curriculumId/lessons/:itemId/quizzes/:quizId/solve",
    name: "teacher_study_plan_lesson_quizzes_solve",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan Lesson Quiz Solve" */ "@/views/teacher/grades/eduClasses/quizzes/solve.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "solve_exam",
      description: "solve_exam",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan/:curriculumId/units/:itemId",
    name: "teacher_study_plan_unit",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan Unit" */ "@/views/teacher/study-plan/assessment.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "manage_unit_quizzes",
      description: "manage_unit_quizzes_hint",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan/:curriculumId/units/:itemId/quizzes/create",
    name: "teacher_study_plan_unit_quizzes_create",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan Unit Quiz Create" */ "@/views/teacher/grades/eduClasses/quizzes/create.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "add_unit_quiz",
      description: "manage_unit_quizzes",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan/:curriculumId/units/:itemId/quizzes/:quizId/edit",
    name: "teacher_study_plan_unit_quizzes_edit",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan Unit Quiz Edit" */ "@/views/teacher/grades/eduClasses/quizzes/edit.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "edit_unit_quiz",
      description: "manage_unit_quizzes",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan/:curriculumId/units/:itemId/quizzes/:quizId/solve",
    name: "teacher_study_plan_unit_quizzes_solve",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan Unit Quiz Solve" */ "@/views/teacher/grades/eduClasses/quizzes/solve.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "solve_exam",
      description: "solve_exam",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan/:curriculumId/:itemKind(quizzes|exams)/:itemId",
    name: "teacher_study_plan_assessment",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan Assessment" */ "@/views/teacher/study-plan/assessment.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "manage_assessment_quizzes",
      description: "manage_assessment_quizzes_hint",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan/:curriculumId/:itemKind(quizzes|exams)/:itemId/class-quizzes/create",
    name: "teacher_study_plan_assessment_quizzes_create",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan Assessment Quiz Create" */ "@/views/teacher/grades/eduClasses/quizzes/create.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "add_class_quiz",
      description: "manage_assessment_quizzes",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan/:curriculumId/:itemKind(quizzes|exams)/:itemId/class-quizzes/:quizId/edit",
    name: "teacher_study_plan_assessment_quizzes_edit",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan Assessment Quiz Edit" */ "@/views/teacher/grades/eduClasses/quizzes/edit.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "edit_class_quiz",
      description: "manage_assessment_quizzes",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan/:curriculumId/:itemKind(quizzes|exams)/:itemId/class-quizzes/:quizId/solve",
    name: "teacher_study_plan_assessment_quizzes_solve",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan Assessment Quiz Solve" */ "@/views/teacher/grades/eduClasses/quizzes/solve.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "solve_exam",
      description: "solve_exam",
      middleware: [isAuth],
    },
  },

  {
    path: "/teacher/grades/:gradeId/edu-classes/:eduClassId/quizzes/add",
    name: "teacher_quizzes_add",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Quizzes Add" */ "@/views/teacher/grades/eduClasses/quizzes/create.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_quizzes",
      description: "manage_organize_quizzes_add",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/grades/:gradeId/edu-classes/:eduClassId/quizzes/:quizId",
    name: "teacher_quizzes_edit",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Quizzes Edit" */ "@/views/teacher/grades/eduClasses/quizzes/edit.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_quizzes",
      description: "manage_organize_quizzes_edit",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/grades/:gradeId/edu-classes/:eduClassId/quizzes/:quizId/solve",
    name: "teacher_quizzes_solve",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Quiz Solve" */ "@/views/teacher/grades/eduClasses/quizzes/solve.vue"
      ),
    meta: {
      layout: "default",
      title: "solve_exam",
      description: "solve_exam",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/year/:yearId/quizzes/:quizId/solutions",
    name: "teacher_quizzes_solutions",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Quizzes Solutions" */ "@/views/teacher/grades/eduClasses/quizzes/solutions.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_quizzes",
      description: "manage_organize_quizzes",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/study-plan/quizzes/:quizId/solutions",
    name: "teacher_study_plan_quiz_solutions",
    component: () =>
      import(
        /* webpackChunkName: "Teacher Study Plan Quiz Solutions" */ "@/views/teacher/grades/eduClasses/quizzes/solutions.vue"
      ),
    meta: {
      layout: "default",
      teacherRouteName: "study_plan",
      title: "solutions",
      description: "view_solutions",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/grades/:gradeId/subjects/:subjectId/curricula/:curriculumId/units/:unitId/lessons/:lessonId/questions",
    name: "teacher_lesson_questions_show",
    component: () =>
      import(
        /* webpackChunkName: "Lesson Questions Show" */ "@/views/teacher/grades/subjects/curricula/units/lessons/questions/"
      ),
    meta: {
      layout: "default",
      title: "questions_in_this_lesson",
      description: "manage_questions_in_this_lesson",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/grades/:gradeId/subjects/:subjectId/curricula/:curriculumId/units/:unitId/lessons/:lessonId/questions/create",
    name: "teacher_lesson_questions_create",
    component: () =>
      import(
        /* webpackChunkName: "Lesson Questions Create" */ "@/views/teacher/grades/subjects/curricula/units/lessons/questions/create.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_questions",
      description: "manage_organize_questions",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/grades/:gradeId/subjects/:subjectId/curricula/:curriculumId/units/:unitId/lessons/:lessonId/questions/edit/:questionId",
    name: "teacher_lesson_questions_edit",
    component: () =>
      import(
        /* webpackChunkName: "Lesson Questions Edit" */ "@/views/teacher/grades/subjects/curricula/units/lessons/questions/edit.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_questions",
      description: "manage_organize_questions",
      middleware: [isAuth],
    },
  },
  {
    path: "/teacher/question/:questionId",
    name: "teacher_question_edit",
    component: () =>
      import(
        /* webpackChunkName: "Question Edit" */ "@/views/teacher/grades/subjects/curricula/units/lessons/questions/edit.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_questions",
      description: "manage_organize_questions",
      middleware: [isAuth],
    },
  },
];
